import React from 'react';
import { Shield, Heart, CreditCard, Headphones } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    { icon: Shield, title: '+10 Anos', color: 'text-red-600', bg: 'bg-red-50' },
    { icon: Heart, title: 'Atendimento Familiar', color: 'text-cyan-600', bg: 'bg-cyan-50' },
    { icon: CreditCard, title: '12x Boleto', color: 'text-orange-600', bg: 'bg-orange-50' },
    { icon: Headphones, title: 'Suporte Total', color: 'text-teal-600', bg: 'bg-teal-50' }
  ];

  return (
    <section className="py-6 md:py-10 bg-gray-50">
      <div className="container mx-auto px-3 sm:px-6 lg:px-8 max-w-7xl">
        <h2 className="text-lg md:text-2xl font-bold text-center text-gray-900 mb-3 md:mb-6">
          Por que escolher a <span className="text-red-600">A.R. Turismo</span>?
        </h2>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className={`${reason.bg} rounded-lg p-3 md:p-6 hover:shadow-lg transition-all duration-300`}
            >
              <div className="flex items-center gap-2 md:gap-3">
                <reason.icon className={`w-5 h-5 md:w-8 md:h-8 ${reason.color}`} />
                <h3 className="text-xs md:text-lg font-bold text-gray-900">{reason.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
